// biome-ignore lint/style/useFilenamingConvention: TanStack Router dynamic route parameter
import { createFileRoute, Outlet } from "@tanstack/react-router";
import {
  IncompleteUrlFallback,
  OrgProjectErrorFallback,
} from "@/lib/org-project-context/error-fallbacks";

export const Route = createFileRoute("/_authenticated/orgs/$organizationId")({
  component: () => <Outlet />,
  errorComponent: OrgProjectErrorFallback,
  notFoundComponent: IncompleteUrlFallback,
});
